import React, { useEffect, useMemo, useState } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { get, isEmpty } from 'lodash';
import { Listings } from 'containers/AppContainer/typings';
import {
  CorporealDocument,
  JudgementADDDocumentType,
} from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/typings';
import ImportImagineDocumentButton from 'containers/CourtManagerLegalProceedings/ImagineDocuments/ImportButton';
import {
  ExpertReportType,
  IVehiculeExpertise,
  IVictimExpertise,
} from 'containers/common/LegalProceedings/ExpertReport/typings';
import ExpertReport from 'containers/common/LegalProceedings/ExpertReport';
import { Container } from 'containers/CourtManagerLegalProceedings/ExpertReport/styled-components';
import { toast } from 'react-toastify';
import { PAGES } from 'routes';
import { pushTo } from 'containers/services/routes-helper';
import {
  addEvaluationsToExpertReportPayload,
  checkExpertiseOnValidation,
  getExpertReportPayload,
} from 'containers/CourtManagerLegalProceedings/ExpertReport/utils';
import { handleOpenDocument } from 'services/utils';
import messages from 'containers/CourtManagerLegalProceedings/JudgementAdd/messages';
import { translate } from 'containers/services/translate';
import { IUploadedDocument } from 'containers/LawyerLegalProceedingsPage/typings';
import { useFormatExpertReportState } from 'containers/common/LegalProceedings/ExpertReport/FormsByExpertiseType/hooks';
import { useDisplayActionButtons } from 'containers/CourtManagerLegalProceedings/ExpertReport/hooks';
import { Claim } from 'containers/PreOpeningPage/typings';
import { hasFeature } from 'features/fflip-helpers';
import {
  extractExpertReport,
  getDeactivationButton,
} from 'containers/common/LegalProceedings/ExpertReport/FormsByExpertiseType/utils';
import { PROCEDURE_TYPES } from 'containers/LawyerLegalProceedingsPage/constants';
import userPrivileges, {
  PRIVILEGES,
} from 'containers/services/security/user-privileges';
import { FEATURES } from 'features/features';
import * as featureService from 'features/fflip-helpers';
import VisibilityIcon from '@material-ui/icons/Visibility';
import Document from 'components/Document';
import { DOCUMENT_TYPES } from 'constants/global';
import RejectionDialog from 'containers/CourtManagerLegalProceedings/ExpertReport/RejectionDialog';
import JudgementValidationButtons from 'containers/common/LegalProceedings/JudgementValidationButtons';
import {
  EMPTY_SUPPORT_DOC,
  SUPPORT_DOC_EXPERT_REPORT_ID,
} from 'containers/LawyerRecapPage/constants';
import UploadDocumentBloc from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/UploadDocumentBloc';
import ValidationDialog from 'containers/CourtManagerLegalProceedings/ExpertReport/ValidationDialog';
import { resolveSagisClaim } from 'helpers/utils';
import { priorityClaimReason } from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/utils';
import { useSelector } from 'react-redux';
import DecisionDropDownSupportDocument from 'containers/common/LegalProceedings/DecisionDropDownSupportDocument';
import { Grid } from '@material-ui/core';
import {
  STATUS_PENDING,
  STATUS_VALIDATED,
} from 'containers/LawyerFeeNote/constants';
import { VictimType } from 'typings/globalTypes';

export interface CourtManagerExpertReportProps {
  intl: IntlShape;
  judgementAddDocuments: JudgementADDDocumentType[];
  listings: Listings;
  claimId: number;
  claimNumber: string;
  requestGetExpertiseRaport: Function;
  expertiseReport: ExpertReportType;
  isManager: boolean;
  requestValidateExpertReport: Function;
  lawyer: string;
  uploadDocument: Function;
  uploadedDocument: IUploadedDocument;
  resetUploadedDocument: Function;
  claim: Claim;
  policyInfo: any;
  victims: VictimType[];
  judiciaryProcessId: number;
  documentId?: string;
  setDocumentId?: Function;
  requestCreateExpertiseRaport?: Function;
  currentIndexTabManager: any;
  requestAddExpertiseSupportDocument?: Function;
  hasJom?: boolean;
  sagisVictimInfo: any;
  sagisOpposingParties: any;
  isConsultation: boolean;
  requestMakeDecisionSupportDocument?: Function;
  imagineDocuments: any;
  dahirAmount: any;
  expertiseRaportFirstInstance: any;
  requestGetDocByDocumentumId: Function;
}

export const CourtManagerExpertReport: React.FC<CourtManagerExpertReportProps> = ({
  ...props
}): JSX.Element => {
  const [expertReportState, setExpertReportState] = useFormatExpertReportState(
    props.judgementAddDocuments,
    props.expertiseReport,
  );
  const [isRejectionDialogOpen, setIsRejectionDialogOpen] = useState<boolean>(
    false,
  );
  const [deactivateButton, setDeactivateButton] = useState([] as any);

  const expertReport = useMemo(
    () =>
      extractExpertReport(
        expertReportState,
        (v: IVictimExpertise) => !isEmpty(v.victimExpertise),
        (v: IVehiculeExpertise) => !isEmpty(v.vehiculeExpertise),
      ),
    [props.expertiseReport, expertReportState],
  );

  const { victimExpertises, vehiculeExpertises } = expertReport;

  const [isDecisionDialgOpen, setIsDecisionDialgOpen] = useState<boolean>(
    false,
  );
  const [supportDocument, setSupportDocument] = useState({
    ...EMPTY_SUPPORT_DOC,
  });
  const priorityReasonClaimId = useSelector((state: any) =>
    get(state.toJS(), ['recap', 'claimRecap', 'claim', 'priorityReasonId']),
  );

  const shouldDisplayActionButtons = useDisplayActionButtons(
    props.expertiseReport,
  );
  const [openDialogValidation, setOpenDialogValidation] = useState(false);

  React.useEffect(() => {
    props.requestGetExpertiseRaport(
      props.claimId,
      PROCEDURE_TYPES.FIRST_INSTANCE,
      props.judiciaryProcessId,
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.claimId, props.judiciaryProcessId, props.currentIndexTabManager]);

  const setExpertiseSupportDocument = (document: CorporealDocument) => {
    if (SUPPORT_DOC_EXPERT_REPORT_ID === props.documentId) {
      setSupportDocument(document);
      props.requestAddExpertiseSupportDocument &&
        props.requestAddExpertiseSupportDocument({
          ...document,
          status: props.isManager ? STATUS_VALIDATED : STATUS_PENDING,
          expertReportId: get(props.expertiseReport, 'id'),
          claimId: props.claimId,
          claimNumber: props.claimNumber,
        });
      props.resetUploadedDocument();
    }
  };

  const handleValidateExpertReport = () => {
    const expertReportWithStatus = getExpertReportPayload(
      props.expertiseReport,
      expertReport,
    );

    const payload = hasFeature(FEATURES.EXPERT_REPORT_SAGIS_EVALUATION)
      ? addEvaluationsToExpertReportPayload(
          props.expertiseReport,
          expertReportWithStatus,
          props.victims,
          props.claim,
          props.policyInfo,
          props.dahirAmount,
        )
      : expertReportWithStatus;
    props.requestValidateExpertReport(
      {
        ...payload,
        isLawyer: false,
        claimNumber: props.claimNumber,
        procedureType: PROCEDURE_TYPES.FIRST_INSTANCE,
        judiciaryProcessId: get(props.expertiseReport, 'judiciaryProcessId'),
        isInboxesActive: featureService.hasFeature(
          FEATURES.ATTRIBUTION_INBOXES_MANAGER,
        ),
        isTrackingActive: featureService.hasFeature(
          FEATURES.TRACKING_ACTIONS_USER,
        ),
        isPriorityActive: featureService.hasFeature(FEATURES.PRIORITY_CLAIM),
        priorityClaimReasonId:
          featureService.hasFeature(FEATURES.PRIORITY_CLAIM) &&
          priorityReasonClaimId !== 4
            ? priorityClaimReason(
                get(payload, 'sagisEvaluations', []),
                !isEmpty(
                  get(resolveSagisClaim(props.policyInfo), 'offeredRisks', []),
                )
                  ? get(resolveSagisClaim(props.policyInfo), 'offeredRisks', [])
                      .map((el: any) => Number(el.riskProvisions))
                      .reduce(
                        (accumulator: any, currentValue: any) =>
                          accumulator + currentValue,
                      )
                  : 0,
                props.listings,
                get(expertReport, 'victimExpertises', []),
              )
            : undefined,
      },
      successCallBack,
    );
  };

  const successCallBack = () => {
    const { lawyer } = props;
    toast.success(
      translate(messages.courtManagerValidationDialogSuccessMessage, props, {
        lawyer,
      }),
    );
    setOpenDialogValidation(false);
    !featureService.hasFeature(FEATURES.EVOLUTIONS_FEE_NOTE) &&
      pushTo(PAGES.COURT_MANAGER_ASSIGNED_CLAIM);
  };

  const expertiseSupportDocuments = get(
    props.expertiseReport,
    'supportDocuments',
    [],
  ).filter(
    (el: any) => el.type === DOCUMENT_TYPES.SUPPORT_DOCUMENT_EXPERT_REPORT,
  );
  useEffect(() => {
    setDeactivateButton(
      getDeactivationButton(victimExpertises, vehiculeExpertises),
    );
  }, [victimExpertises, vehiculeExpertises]);
  return (
    <Container id="court-manager-expert-report">
      <ExpertReport
        listings={props.listings}
        claimId={props.claimId}
        uploadDocument={props.uploadDocument}
        uploadedDocument={props.uploadedDocument}
        resetUploadedDocument={props.resetUploadedDocument}
        expertReportState={expertReportState}
        setExpertReportState={setExpertReportState}
        expertReport={props.expertiseReport}
        setIsDecisionDialgOpen={setIsDecisionDialgOpen}
        isDecisionDialgOpen={isDecisionDialgOpen}
        isManager={
          !props.isConsultation &&
          userPrivileges.userHasPrivilege(PRIVILEGES.ISCOURTMANAGER)
        }
        isAssignedLawyer={false}
        claimNumber={props.claimNumber}
        victimExpertises={victimExpertises}
        vehicleExpertises={vehiculeExpertises}
        judgementAddDocuments={props.judgementAddDocuments}
        setDeactivateButton={setDeactivateButton}
        deactivateButton={deactivateButton}
        judiciaryProcessId={props.judiciaryProcessId}
        documentId={props.documentId}
        setDocumentId={props.setDocumentId}
        requestCreateExpertiseRaport={props.requestCreateExpertiseRaport}
        requestValidateExpertReport={props.requestValidateExpertReport}
        requestGetExpertiseRaport={props.requestGetExpertiseRaport}
        victims={props.victims}
        claim={props.claim}
        policyInfo={props.policyInfo}
        hasJom={props.hasJom}
        sagisVictimInfo={props.sagisVictimInfo}
        imagineDocuments={props.imagineDocuments}
        sagisOpposingParties={props.sagisOpposingParties}
        dahirAmount={props.dahirAmount}
        expertiseRaportFirstInstance={props.expertiseRaportFirstInstance}
        requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
      />
      {featureService.hasFeature(FEATURES.ADD_SUPPORT_DOCUMENTS) &&
        !props.isConsultation &&
        !isEmpty(props.expertiseReport) &&
        !userPrivileges.userHasPrivilege(PRIVILEGES.ISCOURTMONITORINGMANAGER) &&
        featureService.hasFeature(FEATURES.MANAGE_CLAIM_BY_MANAGER) && (
          <main>
            {isEmpty(expertiseSupportDocuments) && (
              <section className="add-recap-bloc">
                {props.resetUploadedDocument &&
                  props.uploadDocument &&
                  props.uploadedDocument && (
                    <>
                      <div className="add-recap-bloc-title">
                        {translate(messages.supportDocument, props)}
                      </div>
                      <Grid container direction="row" spacing={2}>
                        <Grid item xs={4}>
                          <UploadDocumentBloc
                            index={1}
                            document={supportDocument}
                            setDocument={setExpertiseSupportDocument}
                            resetUploadedDocument={props.resetUploadedDocument}
                            uploadDocument={props.uploadDocument}
                            uploadedDocument={props.uploadedDocument}
                            docType={
                              DOCUMENT_TYPES.SUPPORT_DOCUMENT_EXPERT_REPORT
                            }
                            setDocumentId={props.setDocumentId}
                            docId={SUPPORT_DOC_EXPERT_REPORT_ID}
                          />
                        </Grid>
                        <Grid item xs={3} style={{ marginTop: '20px' }}>
                          {!isEmpty(props.imagineDocuments) &&
                            featureService.hasFeature(
                              FEATURES.TRAITEMENT_IMAGINE_DOC,
                            ) && (
                              <ImportImagineDocumentButton
                                listings={props.listings}
                                managerNotifcationsInboxes={
                                  props.imagineDocuments
                                }
                                claimId={props.claimId}
                                imagineDocuments={props.imagineDocuments}
                                claimSagisInfo={resolveSagisClaim(
                                  props.policyInfo,
                                )}
                                uploadDocument={props.uploadDocument}
                                uploadedDocument={props.uploadedDocument}
                                setUploadedDocs={setExpertiseSupportDocument}
                                documentName={
                                  DOCUMENT_TYPES.SUPPORT_DOCUMENT_EXPERT_REPORT
                                }
                                documentType={
                                  DOCUMENT_TYPES.SUPPORT_DOCUMENT_EXPERT_REPORT
                                }
                                documentId={SUPPORT_DOC_EXPERT_REPORT_ID}
                                setDocumentId={
                                  props.setDocumentId
                                    ? props.setDocumentId
                                    : () => {}
                                }
                                requestGetDocByDocumentumId={
                                  props.requestGetDocByDocumentumId
                                }
                              />
                            )}
                        </Grid>
                      </Grid>
                    </>
                  )}
              </section>
            )}
          </main>
        )}

      {featureService.hasFeature(FEATURES.ADD_SUPPORT_DOCUMENTS) &&
        !isEmpty(expertiseSupportDocuments) && (
          <section className="add-recap-bloc">
            <div className="add-recap-bloc-title">
              {translate(messages.supportDocument, props)}
            </div>
            <div className="support-document-info">
              <Document
                name={get(expertiseSupportDocuments[0], 'name', '')}
                type={get(expertiseSupportDocuments[0], 'type', '')}
                icon={
                  <VisibilityIcon
                    className="consult"
                    onClick={handleOpenDocument(
                      expertiseSupportDocuments[0] as any,
                      props.requestGetDocByDocumentumId,
                    )}
                  />
                }
              />
              {props.isManager && !props.isConsultation && (
                <DecisionDropDownSupportDocument
                  claimId={props.claimId}
                  claimNumber={props.claimNumber}
                  judiciaryProcessId={props.judiciaryProcessId}
                  supportDocument={expertiseSupportDocuments[0]}
                  requestMakeDecisionSupportDocument={
                    props.requestMakeDecisionSupportDocument
                  }
                  claim={props.claim}
                  procedureType={PROCEDURE_TYPES.FIRST_INSTANCE}
                />
              )}
            </div>
          </section>
        )}
      {shouldDisplayActionButtons &&
        !props.isConsultation &&
        userPrivileges.userHasPrivilege(PRIVILEGES.ISCOURTMANAGER) && (
          <JudgementValidationButtons
            onValidation={() =>
              checkExpertiseOnValidation(expertReport, props.expertiseReport)
                ? setOpenDialogValidation(true)
                : handleValidateExpertReport()
            }
            onCancel={() =>
              !featureService.hasFeature(FEATURES.EVOLUTIONS_FEE_NOTE) &&
              pushTo(PAGES.COURT_MANAGER_ASSIGNED_CLAIM)
            }
            cancelMessage={messages.courtManagerJudgementDecisionCancel}
          />
        )}
      {featureService.hasFeature(FEATURES.MANAGE_CLAIM_BY_MANAGER) &&
        !props.isConsultation && (
          <ValidationDialog
            open={openDialogValidation}
            handleClose={() => setOpenDialogValidation(false)}
            handleValidate={handleValidateExpertReport}
          />
        )}
      <RejectionDialog
        isRejectionDialogOpen={isRejectionDialogOpen}
        setIsRejectionDialogOpen={setIsRejectionDialogOpen}
        requestValidateExpertReport={props.requestValidateExpertReport}
        expertReport={expertReport}
        expertiseReport={props.expertiseReport}
        lawyer={props.lawyer}
        claimId={props.claimId}
        claimNumber={props.claimNumber}
        judiciaryProcessId={props.judiciaryProcessId}
      />
    </Container>
  );
};

export default injectIntl(CourtManagerExpertReport);
